export enum TriggeringEvent {
  BOOKING_PLACED = 'BookingPlaced',
  REVIEW_GIVEN = 'ReviewGiven',
  PERSONALIZED_OFFER_RISED = 'PersonalizedOfferRised',
}

export enum UserFeedback {
  REJECTED = 'rejected',
  POSTPONED = 'postponed',
  NEGATIVE = 'negative',
  POSITIVE = 'positive',
}
